import { axiosInstance } from "../../utils/axios";
import { Dimension } from "../models/dimension";
import { Attribute } from "../models/attribute";
import { DimensionItem, DimensionTreeItem } from "../../components/coobjects/tree-pills-input/TreeAmountSelector";
import { getVersionedApiUrl } from "../../utils/helpers/ApiResolver";

export function fetchDimensions(dbId: string, includeAnalytical?: boolean): Promise<Dimension[]> {
  let queryParams = new URLSearchParams();
  if (includeAnalytical) {
    queryParams.set("includeAnalytical", "true");
  }
  const baseApiUrl = `/dimensions/${dbId}`;
  const url = queryParams.size > 0 ? baseApiUrl + `?${queryParams}` : baseApiUrl;
  return axiosInstance.get(url).then((response) => response.data);
}

export function fetchChildrenDimension(dbId: string, nodeId: string): Promise<Dimension[]> {
  return axiosInstance.get(`/dimensions/${dbId}/${nodeId}/children`).then((response) => response.data);
}

export function fetchDimensionAttribute(dbId: string, nodeId: string, hierarchyOid?: string): Promise<Attribute[]> {
  const hierarchyQueryParam = hierarchyOid ? `?hierarchyOid=${hierarchyOid}` : "";
  return axiosInstance
    .get(`/dimensions/${dbId}/${nodeId}/attributes${hierarchyQueryParam}`)
    .then((response) => response.data);
}

export function searchDimensionsWithHierarchy(
  dbId: string,
  nodeId: string,
  hierarchyOid: string,
  searchText: string
): Promise<Dimension[]> {
  return axiosInstance
    .get(`${getVersionedApiUrl("/dimensions")}/${dbId}/${nodeId}/${hierarchyOid}?searchText=${searchText}`)
    .then((response) => response.data);
}

export function searchDimensions(dbId: string, nodeId: string, searchText: string): Promise<Dimension[]> {
  return axiosInstance
    .get(`${getVersionedApiUrl("/dimensions")}/${dbId}/${nodeId}?searchText=${searchText}`)
    .then((response) => response.data);
}

export function mapDimensionToDimensionItem(dimension: Dimension, allowNodes = true): DimensionItem {
  const selectable = allowNodes ? dimension.selectable : dimension.selectable && dimension.leaf; // ? metadata.allowsLeafs : metadata.allowsNodes);

  return {
    data: dimension,
    oid: dimension.oid,
    code: dimension.code,
    label: dimension.label,
    type: dimension.type,
    desc: dimension.desc,
    nodeType: dimension.type,
    index: dimension.index,
    leaf: dimension.leaf,
    multiSelectable: dimension.multiSelectable,
    selectable: selectable,
    hierarchical: dimension.hierarchical,
    mandatory: dimension.mandatory,
    parent: dimension.parent ? mapDimensionToDimensionItem(dimension.parent, allowNodes) : null,
    children: dimension.children?.map((childrenDimension) => {
      return mapDimensionToDimensionItem(childrenDimension, allowNodes);
    }),
  };
}

export function mapNodeToDataItem(node: DimensionItem): DimensionTreeItem {
  return {
    ...node,
    hasChildren: !node.leaf && !(node.data.hasChildren === false), //ignore hasChildren undefined
    children: node.children?.map((child) => mapNodeToDataItem(child)) ?? [],
  };
}
